import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  // started, finished, paused, resumed, interrupted?
  status: 'idle',
  // recording new route: true/false/"paused"
  recording: false,
  // Data object to be saved
  id: -1,
  title: '',
  startTime: null,
  endTime: null,
  typeId: -1,
  typeName: '',
  geoData: [],
  // Array to save currently recorded geodata to
  tmpCoords: [],
  // extended geojson data to be put in "properties" of geojson object; adds more data in this order:
  // [longitutde, latitude, altitude, timestamp, heading, spead, accuracy, altitudeAccuracy, recording, distance, steps]
  tmpCoordsExt: [],
  // { km: int, m: int }
  totalDistance: {
    feet: '0.000',
    inches: '0.000',
    km: '0.000',
    m: '0.000',
    miles: '0.000',
    seamiles: '0.000',
    yards: '0.000'
  },
  speed: 0,
  totalSteps: {}
}

export default {
  state,
  mutations,
  actions,
  getters
}
